export interface AddTagsDrawerState {
  isAddTagsDrawerOpen: boolean;
}

export const initialAddTagsDrawerState: AddTagsDrawerState = {
  isAddTagsDrawerOpen: false,
};
